import { Selector } from "react-redux";

import { ExtendedPropertiesType, TagsType } from "@multiweb/types/multiweb";
import { IAppState } from "@multiweb/types/react";
import { IFormState } from "./types";

/**
 * Získá z globálního stavu formuláře podle `formKey`.
 * Pokud pro daný klíč neexistuje instance, vrací undefined.
 *
 * @param state
 * @param formKey Klíč formláře.
 */
export const getFormInstance: Selector<IAppState, Readonly<IFormState> | undefined, string> = (
    state,
    formKey,
) => state.forms[formKey];

/**
 * Vrací extended properties pro formulář daný klíčem.
 * Pokud pro daný klíč neexistuje registrovaný formulář, vrací undefined.
 *
 * @param state
 * @param formKey Klíč formuláře.
 */
export const getFormExtendedProperties: Selector<IAppState, Readonly<ExtendedPropertiesType> | undefined, string> = (
    state,
    formKey,
) => getFormInstance(state, formKey)?.extendedProperties;

/**
 * Vrací tagy pro formulář daný klíčem.
 * Pokud pro daný klíč neexistuje registrovaný formulář, vrací undefined.
 *
 * @param state
 * @param formKey Klíč formuláře.
 * @returns
 */
export const getFormTags: Selector<IAppState, Readonly<TagsType> | undefined, string> = (
    state,
    formKey,
) => getFormInstance(state, formKey)?.tags;
